var map = {
	"./content.vue": "2015",
	"./effect.vue": "c2d5",
	"./foundation.vue": "aca0",
	"./introduction.vue": "2869",
	"./news.vue": "210a",
	"./newsDetails.vue": "851f",
	"./target.vue": "c84b",
	"./video.vue": "d44c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6768";